import { render } from "./EmployeeForm.vue?vue&type=template&id=b3aeda3c&scoped=true"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts"

import "./EmployeeForm.vue?vue&type=style&index=0&id=b3aeda3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3aeda3c"

export default script